import { useState } from 'react'
import {
	Box,
	Button,
	Card,
	CardContent,
	TextField,
	Typography,
} from '@mui/material'
import { toastHelper } from '../../../util/toastHelper'
import { isEmail } from 'validator'
import { useNavigate } from 'react-router-dom'

const API_VERSION = 'v1'
const REQUEST_URL = `${process.env.REACT_APP_REQUEST_URL}/api/${API_VERSION}`

export const PreRegistrationPage = () => {
	const navigate = useNavigate()

	const [data, setData] = useState({
		firstName: '',
		lastName: '',
		email: '',
	})
	const [error, setError] = useState(false)
	const [helperText, setHelperText] = useState('')

	const preRegister = async (e) => {
		e.preventDefault()

		const isValid = isEmail(data.email)
		setError(!isValid)
		setHelperText(isValid ? '' : 'Please enter a valid email address.')
		if (!isValid) {
			return
		}

		if (!data.firstName || !data.lastName || !data.email) {
			return toastHelper('Please fill out all the fields', 'error')
		}

		try {
			const res = await fetch(`${REQUEST_URL}/pre-register/register`, {
				method: 'POST',
				credentials: 'include',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			})
			const result = await res.json()
			toastHelper(result.message, result.success ? 'success' : 'error')

			if (result.success) {
				navigate('/thanks-for-registering')
			}
		} catch (err) {
			console.log(err.message)
		}
	}

	const handleChange = (e) => {
		const input = e.target.value.trim()
		setData({
			...data,
			[e.target.name]: input,
		})
	}

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<img
				src={'/images/ontimebridelogo.svg'}
				alt="logo"
				loading="lazy"
				style={{
					width: 'clamp(20em, 70vw, 50em)',
				}}
			/>
			<Card
				sx={{
					marginTop: '5dvh',
					flexDirection: 'column',
					height: '30em',
					width: 'clamp(20em, 80vw, 40em)',
				}}
			>
				<CardContent>
					<Typography gutterBottom variant="h3">
						Pre-Registration
					</Typography>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
						}}
						component="form"
						onSubmit={preRegister}
					>
						<TextField
							required
							name="firstName"
							value={data.firstName}
							margin="normal"
							label="First Name"
							onChange={handleChange}
						/>
						<TextField
							required
							name="lastName"
							value={data.lastName}
							margin="normal"
							label="Last Name"
							onChange={handleChange}
						/>
						<TextField
							required
							name="email"
							value={data.email}
							margin="normal"
							label="Email"
							onChange={handleChange}
							error={error}
							helperText={helperText}
						/>
						<Button type="submit">Pre-register</Button>
					</Box>
				</CardContent>
			</Card>
		</Box>
	)
}
